import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { htmlT } from 'utils/translation';

import Form from 'features/Form';
import Button from 'components/Button';

import {
  useScreenClass,
  Row,
  Col,
  Hidden,
  Visible
} from 'components/Grid';

import {
  Container,
  Content,
  Title,
  Text,
  GetInTouch,
  ContactSales,
  Share,
  ShareButton,
  Icon,
} from './styles';
import * as webView from 'utils/webView';
import * as socialShare from 'utils/socialShare';

const BASE_URL = process.env.REACT_APP_APPLICATION_BASE_URL;

const Body = ({ isCompacted }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const screenClass = useScreenClass();
  const [showForm, setShowForm] = useState(false);
  const switchShowForm = () => setShowForm(!showForm);
  const isTabletAndCompact = screenClass === 'md' && isCompacted;

  const handleGetStartedClick = () => {
    window.location.href = `${BASE_URL}/registration${location.search}`;
  };

  const justifyAlign = useMemo(() => {
    if (screenClass === 'xs' || isTabletAndCompact) {
      return 'center';
    }
    if (isCompacted) {
      return 'flex-end';
    }
    return 'flex-start';
  }, [isCompacted, screenClass, isTabletAndCompact]);

  return (
    <Container flex align="center" justify={justifyAlign}>
      <Content>
        <Hidden xs>
          <Title center={isTabletAndCompact}>{t('HERO.TITLE')}</Title>
          {!isCompacted && <Text>{t('HERO.TEXT')}</Text>}
        </Hidden>
        <Visible xs>
          <Title.xs center={isCompacted}>{t('HERO.TITLE')}</Title.xs>
          {!isCompacted && <Text.xs>{t('HERO.TEXT')}</Text.xs>}
        </Visible>
        <Row align="center" justify="center" bottom={screenClass === 'xs' ? 70 : 32}>
          <Col xs={12} sm={6} bottom={screenClass === 'xs' ? 22 : 0}>
            <Button onClick={handleGetStartedClick}>{t('HERO.GET_STARTED')}</Button>
          </Col>
          <Col xs={12} sm={6} align={screenClass !== 'xs' ? 'left' : 'center'}>
            <Hidden xs>
              <GetInTouch onClick={switchShowForm}>{htmlT(t, 'HERO.GET_IN_TOUCH')}</GetInTouch>
            </Hidden>
            <Visible xs>
              <ContactSales onClick={switchShowForm}>{htmlT(t, 'HERO.GET_IN_TOUCH')}</ContactSales>
            </Visible>
          </Col>
        </Row>
        <Row align="center">
          <Col xs={12} sm={7} bottom={12} align={screenClass !== 'xs' ? 'left' : 'center'}>
            <Share>{t('HERO.SHARE')}</Share>
          </Col>
          <Col xs={12} sm={5} bottom={12} align={screenClass !== 'xs' ? 'left' : 'center'}>
            <ShareButton onClick={() => webView.openURL(socialShare.getTwitterShareURL(t('SOCIAL_MEDIA_SHARE.TEXT')), { popup: true })}>
              <Icon alt="Twitter logo" src="/assets/icons/social/twitter.svg" />
            </ShareButton>
            <ShareButton onClick={() => webView.openURL(socialShare.getFacebookShareURL(t('SOCIAL_MEDIA_SHARE.TEXT')), { popup: true })}>
              <Icon alt="Facebook logo" src="/assets/icons/social/facebook.svg" />
            </ShareButton>
            <ShareButton onClick={() => webView.openURL(socialShare.getWhatsAppShareURL(t('SOCIAL_MEDIA_SHARE.TEXT')), { popup: true, width: 750, height: 600 })}>
              <Icon alt="WhatsApp logo" src="/assets/icons/social/whatsapp.svg" />
            </ShareButton>
            <ShareButton onClick={() => webView.openURL(socialShare.getLinkedInShareURL(t('SOCIAL_MEDIA_SHARE.TEXT')), { popup: true, width: 750, height: 600 })}>
              <Icon alt="LinkedIn logo" src="/assets/icons/social/linkedin.svg" />
            </ShareButton>
          </Col>
        </Row>
      </Content>
      <Form show={showForm} onClose={switchShowForm} />
    </Container>
  );
};

Body.propTypes = {
  isCompacted: PropTypes.bool
};

export default Body;
